var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlagIl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1100,
    height: 800,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 H 1100 V 800 H 0 Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 0,75 H 1100 V 200 H 0 Z",
    fill: "#0038b8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M 0,600 H 1100 V 725 H 0 Z",
    fill: "#0038b8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M 423.81566,472.85253 H 676.18435 L 550.00001,254.29492 Z m 126.18435,72.85255 126.1843,-218.55765 H 423.81566 Z",
    fill: "none",
    stroke: "#0038b8",
    strokeWidth: 27.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagIl);
export default __webpack_public_path__ + "static/media/flag-il.2eb5f48a9b5276f83d7cedc10bac7b4b.svg";
export { ForwardRef as ReactComponent };